module.exports = __webpack_public_path__ + "img/ufa6811.0092e96e.gif";